import Vue from "vue";
import VueRouter from "vue-router";
import {overWriteRoute, findRoutes} from '@/plugin/routes/RouterFunctions'
import {dashboardLink, siteLink} from "../main";

import {dashboardRoutes} from '@/plugin/routes/DashboardRoutes'
import {siteRoutes} from '@/plugin/routes/SiteRoutes'
import store from '@/store'
import NotFound from "../views/NotFound.vue";
import SiteTemplate from "../views/site/SiteTemplate";

Vue.use(VueRouter);

// import auth views
import RedirectLoading from "../components/RedirectLoading";
import {getBaseDomain} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";


const routes = [
    {
        path: '/',
        name: 'Home',
        component: RedirectLoading,
    },
    ...dashboardRoutes,
    {
        path: '/template',
        name: 'Template',
        component: SiteTemplate,
        children: [
            ...siteRoutes
        ]
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    },
]


const router = new VueRouter({
    routes,
    mode: "history",
});

router.beforeEach((to, from, next) => {
    const routerName = to.name;
    const authRouters = [
        'Login', 'Register', 'ForgetPassword', 'EmailResetPassword', 'VerifiedEmail',
        'VerifiedCellphone', 'CellphoneResetPassword', 'Factor', 'verifyTransaction',
        'verifyTransactionWithoutAuthentication', 'Home', 'VerifyEmailRequest', 'SingleCourse', 'SingleChat', 'Product',
        'SinglePage', 'SinglePost', 'WishListUser', 'FactorWithSlug'
    ];

    let storeRestriction = findAttributeOnSiteInfo('restrict_store_access_to_dashboard')[0];

    if(store.getters['User/isUserStore'] && storeRestriction == 1){
        window.location.href = siteLink
    }

    if (authRouters.indexOf(routerName) > -1) {

        let query = Object.keys(to.query)
            .map(key => {
                return (
                    encodeURIComponent(key) + '=' + encodeURIComponent(to.query[key])
                )
            })
            .join('&')

        window.location.href = siteLink + to.path + `?${query}`
    }
    next()
})

export default router;
